// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-share[data-v-e2cbbbf8]{display:flex;float:right;margin-top:-30px;padding-right:10px}.social-share-bottom[data-v-e2cbbbf8]{display:flex}.social-share-bottom div[data-v-e2cbbbf8]{padding:5px}@media(max-width:960px){.social-share[data-v-e2cbbbf8]{margin-top:0;margin-bottom:20px}}.social-share div[data-v-e2cbbbf8]{padding:5px}[data-v-e2cbbbf8] button{padding:5px 10px!important}[data-v-e2cbbbf8] button img{width:25px;height:25px;position:relative!important;left:0!important}", ""]);
// Exports
module.exports = exports;
